<template>
  <LoanForm :selectedProduct="selectedProduct" @submit="submitLoanApplication"
            :showEir="isShownEir" :showApr="isShownApr"
            :campaignText="$t('LoanFormPage.campaignConditionsReturningCustomer')">
    <template v-slot:products>
      <div class="text-muted small">{{ $t('LoanFormPage.returningCustomerNotice') }}</div>
    </template>
  </LoanForm>
</template>

<script>
import LoanForm from '@shared/components/LoanForm'

export default {
  name: 'ReturningCustomerLoanFormPage',
  components: { LoanForm },
  props: ['showEir', 'showApr'],
  data() {
    return {
      selectedProduct: null
    }
  },
  computed: {
    isShownApr() {
      return this.showApr === undefined ? true : this.showApr
    },
    isShownEir() {
      return this.showEir === undefined ? false : this.showEir
    }
  },
  created() {
    this.$http.get(`/api/offers/${this.$route.params.offerId}`)
        .then(response => {
          this.selectedProduct = response.data
        })
  },
  methods: {
    submitLoanApplication() {
      this.$router.push({ name: 'with-offer-agreement' })
    }
  }
}
</script>
